module.exports = __webpack_public_path__ + "assets/img/2b306cf24ca1482445b1096b3f9327cc.png";